'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SITE = SITE || {
  data: {
    url: '',
    $body: $('body'),
    $window: $(window),
    $MQ: 'PC',
    scrollTop: 0,
    lockTop: 0,
    winW: '',
    winH: '',
    jqXHR: '',
    scrollTopflag: false,
    transitonEnd: 'webkitTransitionEnd mozTransitionEnd msTransitionEnd oTransitionEnd transitionend',
    animationStart: 'webkitAnimationStart mozAnimationStart msAnimationStart oAnimationStart animationStart',
    animationEnd: 'webkitAnimationEnd mozAnimationEnd msAnimationEnd oAnimationEnd animationEnd'
  },
  pageScript: {
    init: {}
  }
};

SITE.pageScript = function () {

  // コンストラクタ  =================================================================
  function init() {
    getWindowSize();
    getScrollTop();
    SITE.data.$window.on('resize', getWindowSize);
    SITE.data.$window.on('scroll', getScrollTop);
    $('.js-anchorLink')[0] && initAnchorLink();

    initAdjustMovie();
    initIntroAnimation();
    initCartTurnover();
    initSlider();
    initSnapSlider();
    initModal();
    initVideoControl();
  }

  // private functions  ==========================================================


  /**
   * 画像読み込み数カウント
   */
  function countImgLoaded(target, runnninng) {
    var deferred = new $.Deferred();

    var $img = target ? target.find('img') : $('img');
    var total = $img.length;
    var count = 0;

    $img.each(function () {
      var myImg = new Image();

      myImg.src = $(this).attr('src');

      myImg.onload = function () {
        count++;

        var progress = count / total;
        if (runnninng) {
          runnninng(progress);
        }

        if (count >= total) {
          deferred.resolve();
        }
      };
      myImg.onerror = function () {
        deferred.reject();
      };
    });

    return deferred.promise();
  }

  /**
   * WINDOWサイズ取得
   */
  function getWindowSize() {
    SITE.data.winW = SITE.data.$window.width();
    SITE.data.winH = SITE.data.$window.height();

    var cssContent = $('body').css('content');
    if (cssContent.indexOf('portrait') != -1) {
      SITE.data.$MQ = 'PORTRAIT';
    } else {
      SITE.data.$MQ = 'LANDSCAPE';
    }

    if (SITE.data.oldMQ && SITE.data.oldMQ !== SITE.data.$MQ) {
      SITE.data.$window.trigger('onBreakpointChange');
    }

    SITE.data.oldMQ = SITE.data.$MQ;
  }

  /**
   * スクロール値取得
   */
  function getScrollTop() {
    SITE.data.scrollTop = SITE.data.$window.scrollTop();
  }

  /*
  *
  *  アンカーリンク
  *
  */
  function initAnchorLink() {
    $('.js-anchorLink').on('click', function () {
      var href = $(this).attr("href"),
          target = $(href === "#" || href === "" ? 'html' : href),
          targetTop = target.offset().top;

      $('html, body').animate({ scrollTop: targetTop }, 500);
      return false;
    });
  }

  /*
  * 動画のサイズ調整
  */
  var movieW = 1920;
  var movieH = 1080;
  var initAdjustMovie = function initAdjustMovie() {
    adjustMovieSize();
    SITE.data.$window.on('resize', adjustMovieSize);
  };
  var adjustMovieSize = function adjustMovieSize() {
    var movieSize = void 0;
    var areaW = SITE.data.MQ == 'PC' ? SITE.data.winW / 2 : SITE.data.winW;
    var areaH = SITE.data.winH;

    if (areaW / areaH > movieW / movieH) {
      /* ▼ ウィンドウ横長 */
      movieSize = { width: '100%', height: 'auto' };
    } else {
      movieSize = { width: 'auto', height: '100%' };
    }

    $('.js-movie').css(movieSize);
  };

  /**
   * カードをひっくり返すアニメーション
   */
  var cardTimer = void 0;
  var initCartTurnover = function initCartTurnover() {
    $('.js-cardParent').each(function (i) {
      var cardObj = new cardTurnover(i, $(this));
      cardObj.init();
    });
  };

  /*
  * cardTurnover
  *
  */

  var cardTurnover = function () {
    function cardTurnover(id, target) {
      _classCallCheck(this, cardTurnover);

      this.id = id;
      this.$target = target;
      this.intervalTimer;
      this.restartTimer;
      this.max = this.$target.find('.js-card').length - 1;
    }

    _createClass(cardTurnover, [{
      key: 'init',
      value: function init() {
        this.timerSet();
        this.toggleSomeCard();
        this.mouseAction();
      }
    }, {
      key: 'toggleSomeCard',
      value: function toggleSomeCard() {
        var targetIndex = Math.floor(Math.random() * this.max);
        var $newTarget = this.$target.find('.show-b').not('.slick-cloned').eq(targetIndex);
        this.$target.find('.show-a').toggleClass('show-a show-b');
        $newTarget.toggleClass('show-a show-b');
      }
    }, {
      key: 'timerSet',
      value: function timerSet() {
        var _this2 = this;

        this.intervalTimer = setInterval(function () {
          _this2.toggleSomeCard();
        }, 3000);
      }
    }, {
      key: 'mouseAction',
      value: function mouseAction() {
        var _this = this;
        this.$target.find('.js-card').on('mouseenter', function (e) {
          _this.cardMouseEnter(e);
        });
        this.$target.find('.js-card').on('mouseleave', function (e) {
          _this.cardMouseLeave(e);
        });
      }
    }, {
      key: 'cardMouseEnter',
      value: function cardMouseEnter(e) {
        var _this = this;
        _this.$target.find('.show-a').toggleClass('show-a show-b');
        $(e.currentTarget).removeClass('show-b');
        $(e.currentTarget).addClass('show-a');
        clearTimeout(_this.intervalTimer);
        clearTimeout(_this.restartTimer);
      }
    }, {
      key: 'cardMouseLeave',
      value: function cardMouseLeave(e) {
        var _this = this;
        $(e.currentTarget).addClass('show-b');
        $(e.currentTarget).removeClass('show-a');

        this.restartTimer = setTimeout(function () {
          _this.timerSet();
        }, 500);
      }
    }]);

    return cardTurnover;
  }();

  /**
   * イントロアニメーションの判定
   */


  function initIntroAnimation() {
    if (sessionStorage.getItem('daibakusho_loaded')) {
      $('.js-intro').hide();
      $('.js-introBusy').show();
      $('.js-loadBusy').show();
    } else {
      var introAnimateTL = initTimeline();

      // 10秒経ってもロードが終わらない場合は強制でやる
      var alreadyShow = false;
      var timeoutTimer = setTimeout(function () {
        alreadyShow = true;
        $('.js-intro').hide();
        $('.js-loadBusy').show();
      }, 10000);

      countImgLoaded().then(function () {
        if (!alreadyShow) {
          clearTimeout(timeoutTimer);
          $('.js-introBusy').show();
          introAnimateTL.play();
          sessionStorage.setItem('daibakusho_loaded', true);
        }
      }).catch(function () {
        if (!alreadyShow) {
          $('.js-intro').hide();
          $('.js-loadBusy').show();
        }
      });
    }
  }

  /**
   * イントロアニメーションの設定
   */
  var initTimeline = function initTimeline() {
    var TL = gsap.timeline({ paused: true });

    TL.addLabel('step1', 0).addLabel('step2', 'step1+=1').addLabel('step3', 'step2+=1').addLabel('step4', 'step3+=1');

    TL.set('.js-title', { opacity: 0, y: 20 }, 'step1').set('.js-logoSmile', { width: 0 }, 'step1').set('.js-dai', { x: 88 }, 'step1').set('.js-baku', { x: -88 }, 'step1').set('.js-meriyasu', { opacity: 1 }, 'step1').set('.js-daibakusho', { opacity: 0 }, 'step1');

    TL.seek('step1');

    // step1
    TL.to('.js-background', { scale: 1.075, duration: 4 }, 'step1').to('.js-title', { opacity: 1, y: 0, duration: 1 }, 'step1');

    // step2
    TL.to('.js-dai', { x: 66, y: -10, scale: .75, duration: .15 }, 'step2+=0.4').to('.js-dai', { x: 44, y: -15, scale: .5, duration: .15 }, 'step2+=0.55').to('.js-dai', { x: 22, y: -10, scale: .75, duration: .15 }, 'step2+=0.7').to('.js-dai', { x: 0, y: 0, scale: 1, duration: .15 }, 'step2+=0.85').to('.js-baku', { x: -66, y: 10, scale: 1.25, duration: .15 }, 'step2+=0.4').to('.js-baku', { x: -44, y: 15, scale: 1.5, duration: .15 }, 'step2+=0.55').to('.js-baku', { x: -22, y: 10, scale: 1.25, duration: .15 }, 'step2+=0.7').to('.js-baku', { x: 0, y: 0, scale: 1, duration: .15 }, 'step2+=0.85').to('.js-logoSmile', { width: 147, duration: .2 }, 'step2+=0.3').to('.js-meriyasu', { opacity: 0, duration: 1.5 }, 'step2+=0.2').to('.js-daibakusho', { opacity: 1, duration: 1.5 }, 'step2+=0.2');

    // step3
    TL.to('.js-screen1', { height: '100%', duration: .2 }, 'step3+=0.3').to('.js-screen2', { height: '100%', duration: .4 }, 'step3+=0.35');

    // step4
    TL.to('.js-intro', { opacity: 0, duration: 1.4 }, 'step4+=0.2').then(function () {
      $('.js-intro').hide();
      $('.js-loadBusy').show();
    });

    return TL;
  };

  /**
   * スライダー
   */
  var initSlider = function initSlider() {
    $('.js-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 9000,
      draggable: true,
      arrows: false,
      cssEase: 'linear',
      pauseOnHover: false,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }]
    });
  };

  var $snapSlider = void 0;
  var initSnapSlider = function initSnapSlider() {
    $snapSlider = $('.js-snapSlider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      speed: 500,
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: false
    });

    $('.js-slickArrow').on('click', snapSliderControl);
  };
  var snapSliderControl = function snapSliderControl(e) {
    var direction = $(e.target).data('direction');
    if (direction == 'next') {
      $snapSlider.slick('slickNext');
    } else {
      $snapSlider.slick('slickPrev');
    }
  };

  /*
  *  モーダル
  */
  var initModal = function initModal() {
    $('[data-modal-button]').on('click', modalOpen);
    $('[data-modal-close], .p-modal').on('click', modalClose);
  };

  var modalOpen = function modalOpen(e) {
    var $button = $(e.currentTarget);
    var target = $button.data('modal-button');
    if (target == 'itemMap' && SITE.data.$MQ == 'LANDSCAPE') {
      return;
    } else if (target == 'snap') {
      var snapIndex = $button.data('snap') - 1;
      $snapSlider.slick('slickGoTo', snapIndex, true);
    }
    e.preventDefault();
    $('[data-modal-target="' + target + '"]').addClass('is-active');
    screenLock();
  };

  var modalClose = function modalClose(e) {
    var $button = $(e.currentTarget);
    var target = $button.data('modal-close');

    // モーダルの中身以外をクリックした場合の処理
    var $modalElement = $(e.target);
    if (!target && $modalElement.is('.p-modal')) {
      target = $modalElement.data('modal-target');
    }

    $('[data-modal-target="' + target + '"]').removeClass('is-active');
    screenUnlock();
  };

  /*
  * スクロールロック
  *
  */
  function screenLock() {
    $('html, body').addClass('scrollLock');
    $('body').attr('data-scroll', SITE.data.scrollTop);
    $('body').css({
      'position': 'fixed',
      'top': -SITE.data.scrollTop
    });
  };
  function screenUnlock() {
    $('html, body').removeClass('scrollLock');
    $('body').attr('style', '');
    $('html, body').animate({ scrollTop: $('body').attr('data-scroll') }, 0);
  };

  /*
  * 動画の表示をコントロール（iOS対策）
  *
  */
  var initVideoControl = function initVideoControl() {
    videoShowControl();
    SITE.data.$window.on('scroll', videoShowControl);
  };
  var videoShowControl = function videoShowControl() {
    if (SITE.data.scrollTop > SITE.data.winH * 1.5) {
      $('.daibakushoMainvisual').addClass('is-hide');
    } else {
      $('.daibakushoMainvisual').removeClass('is-hide');
    }
  };

  return {
    init: init
  };
}();

SITE.pageScript.init();